module.exports = __webpack_public_path__ + "static/img/work_icon.da1fdcbe.png";